import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUser, selectSignUpState, resetSignUpState } from "../redux/WithcookieSlice";
import axios from "axios";
import { showToast } from "./Toast"; // 토스트 함수 import
import { useTranslation } from "../redux/TranslationHelper";

const SignUpComponent = ({ 
  style,
  content = {},
  data = {},
  pathVariables = {},
  showEmail = true,  // 기본값: 표시
  showBirthday = true,  // 기본값: 표시
  showAddress = true,  // 기본값: 표시
  showCenterCode = true,  // 기본값: 표시
  centerCodeLabel = "센터 코드",  // 기본값: "센터 코드"
  varFields = {
    var01: { 
      show: false, 
      label: "", 
      type: "input", 
      options: [], 
      requred: false,
      content: ""
    },
    var02: { 
      show: false, 
      label: "", 
      type: "input", 
      options: [], 
      requred: false,
      content: ""

    },
    var03: { 
      show: false, 
      label: "", 
      type: "input", 
      options: [], 
      requred: false,      
      content: ""

    }
  }
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // useParams() 대신 props로 받은 데이터 사용
  const referralCodeFromProps = pathVariables.referralCode || content.referralCode || data.referralCode;
  const { loading, signUpSuccess, signUpError, validationErrors: reduxValidationErrors } = useSelector(selectSignUpState);
  
  // check_current API에서 직접 데이터 가져오기
  const [checkCurrentData, setCheckCurrentData] = useState(null);
  const [directReferralCode, setDirectReferralCode] = useState("");

  // withcookieData에서 테마 정보 가져오기
  const withcookieData = useSelector(state => state.withcookie.withcookieData);
  
  // 테마 색상 설정
  const theme = withcookieData?.skin?.theme || {};
  const colorSet = theme?.colorset || {};
  const primaryColor = colorSet?.primary || "#007bff";
  const secondaryColor = colorSet?.secondary || "#6c757d";

  // 기존 skinData 선택자는 유지 (다른 목적으로 사용될 수 있음)
  const skinData = useSelector(state => {
    // Redux 상태 구조에 따라 skin 데이터 추출 방법 변경
    // 여러 가능한 경로 확인
    if (state.withcookie?.skin) return state.withcookie.skin;
    if (state.skin) return state.skin;
    // 전체 state에서 skin 속성 찾기
    for (const key in state) {
      if (state[key]?.skin) return state[key].skin;
    }
    return {};
  });
  
  // 참조 경로 수정: skin 데이터 구조에 맞게 referralCode 접근
  const skinReferralCode = skinData?.referralCode || "";
  
 
  // 로컬 상태 관리
  const [formData, setFormData] = useState({
    user_id: "",
    password: "",
    phone: "",
    name: "",
    referral_code: "",
    email: "",
    birthday: "",
    address: "",
    upperer_code: "",
    left_or_right: "0",
    center_code: "",
    var01: "",
    var02: "",
    var03: "",
    referral_code_from_url: false
  });
  const [localValidationErrors, setLocalValidationErrors] = useState({});
  const [policies, setPolicies] = useState(null);
  const [isSpecifiedLegPolicy, setIsSpecifiedLegPolicy] = useState(false);

  // check_current API 직접 호출
  useEffect(() => {
    const fetchCheckCurrent = async () => {
      try {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
        const response = await axios.get(`${apiBaseUrl}/api/check_current`, {
          withCredentials: true
        });
   
        setCheckCurrentData(response.data);
        
        // skin.referralCode 값 추출
        if (response.data?.skin?.referralCode) {
          setDirectReferralCode(response.data.skin.referralCode);
        }
      } catch (error) {
        console.error(t('check_current API 호출 오류:'), error);
      }
    };
    
    fetchCheckCurrent();
  }, [t]);

  // 리덕스의 validation 에러와 로컬 에러 병합
  const validationErrors = { ...localValidationErrors, ...reduxValidationErrors };

  // 추천인 코드가 있으면 폼 데이터에 설정 (우선순위: API > props > URL)
  useEffect(() => {

    // 1. API에서 직접 가져온 referralCode가 있으면 최우선으로 사용
    if (directReferralCode && directReferralCode.trim() !== "") {
      setFormData(prevData => ({
        ...prevData,
        referral_code: directReferralCode,
        referral_code_from_url: true // 수정 불가능하게 처리
      }));
      
      
    }
    // 2. props로 받은 코드가 있으면 사용
    else if (referralCodeFromProps) {
      setFormData(prevData => ({
        ...prevData,
        referral_code: referralCodeFromProps,
        referral_code_from_url: true
      }));
 
    } 
    // 3. URL에서 직접 추출 시도 (fallback 방식)
    else {
      const pathSegments = window.location.pathname.split('/').filter(Boolean);
      if (pathSegments.length >= 2 && pathSegments[0] === 'signup') {
        const codeFromUrl = pathSegments[1];
        setFormData(prevData => ({
          ...prevData,
          referral_code: codeFromUrl,
          referral_code_from_url: true
        }));
        
       
      }
    }
  }, [referralCodeFromProps, directReferralCode]);

  // 컴포넌트 언마운트 시 회원가입 상태 초기화
  useEffect(() => {
    return () => {
      dispatch(resetSignUpState());
    };
  }, [dispatch]);

  // 컴포넌트 마운트 시 정책 데이터 불러오기
  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
        const response = await axios.get(`${apiBaseUrl}/api/policies/all`);
        setPolicies(response.data);
        
        // SPECIFIED 타입의 legPolicy가 있는지 확인
        if (response.data && response.data.legPolicies && response.data.legPolicies.length > 0) {
          const hasSpecifiedLegPolicy = response.data.legPolicies.some(policy => policy.type === 'SPECIFIED');
          setIsSpecifiedLegPolicy(hasSpecifiedLegPolicy);
        }
      } catch (error) {
        console.error(t('정책 로드 중 오류 발생:'), error);
      }
    };
    
    fetchPolicies();
  }, [t]);

  // 회원가입 성공 시 홈페이지로 리다이렉트
  useEffect(() => {
    if (signUpSuccess) {
      const redirectTimer = setTimeout(() => {
        window.location.href = '/';
      }, 3000); // 3초 후 리다이렉트
      
      return () => clearTimeout(redirectTimer);
    }
  }, [signUpSuccess]);
  const filteredStyle = {...style};
  delete filteredStyle.padding;
  delete filteredStyle.paddingLeft;
  delete filteredStyle.paddingRight;
  delete filteredStyle.paddingTop;
  delete filteredStyle.paddingBottom;
  
  const defaultStyle = {
    padding: '20px', // 고정 패딩 값 설정
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Noto Sans KR, sans-serif',
    maxWidth: '800px',
    margin: '0 auto',
    marginTop: '20px',
    marginBottom: '20px',
    ...filteredStyle // 패딩 속성이 제거된 스타일만 병합
  };


  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%'
  };

  const formRowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    width: '100%'
  };

  const formGroupStyle = {
    flex: '1 1 calc(50% - 15px)',
    minWidth: '250px'
  };

  const inputStyle = {
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    fontSize: '14px',
    width: '100%',
    transition: 'border-color 0.2s'
  };

  const errorInputStyle = {
    ...inputStyle,
    borderColor: '#dc3545',
    backgroundColor: '#fff8f8'
  };

  const labelStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '6px',
    display: 'block'
  };

  const buttonStyle = {
    padding: '12px 20px',
    backgroundColor: primaryColor,
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 'bold',
    marginTop: '20px',
    width: '100%',
    transition: 'background-color 0.2s'
  };

  const sectionTitleStyle = {
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    marginTop: '20px',
    marginBottom: '15px',
    fontSize: '18px',
    fontWeight: 'bold'
  };

  // 입력값 변경 핸들러
  const handleChange = (e) => {
    const { id, value, type } = e.target;
    
    // URL에서 referralCode가 설정된 경우에만 referral_code 필드 변경 방지
    if (id === 'referral_code' && formData.referral_code_from_url) {
      return;
    }
    
    setFormData(prevData => ({
      ...prevData,
      [id]: type === 'radio' ? e.target.value : value
    }));

    // 유효성 검사
    validateField(id, value);
  };

  // 필드별 유효성 검사
  const validateField = (id, value) => {
    let errors = {...localValidationErrors};
    
    switch(id) {
      case 'user_id':
        if (!value.trim()) {
          errors.user_id = t('ID를 입력해주세요');
        } else if (value.length < 2 || value.length > 20) {
          errors.user_id = t('ID는 2~20자로 입력해주세요');
        } else {
          delete errors.user_id;
        }
        break;
        
      case 'password':
        if (!value) {
          errors.password = t('비밀번호를 입력해주세요');
        } 
        else {
          delete errors.password;
        }
        break;
        
      case 'phone':
        // 핸드폰 번호 검증 (숫자만 필수)
        if (!value) {
          errors.phone = t('핸드폰 번호를 입력해주세요');
        } else {
          delete errors.phone;
        }
        break;
        
      case 'name':
        if (!value.trim()) {
          errors.name = t('이름을 입력해주세요');
        } else {
          delete errors.name;
        }
        break;
        
      case 'email':
        if (value && !/\S+@\S+\.\S+/.test(value)) {
          errors.email = t('유효한 이메일 형식이 아닙니다');
        } else {
          delete errors.email;
        }
        break;
        
      // 추천인 코드와 기타 선택적 필드는 특별한 유효성 검사 없음
      default:
        delete errors[id];
        break;
    }
    
    setLocalValidationErrors(errors);
  };

  // 폼 전체 유효성 검사
  const validateForm = () => {
    const errors = {};
    const { user_id, password, phone, name } = formData;
    
    // 아이디 검사
    if (!user_id.trim()) {
      errors.user_id = t('ID를 입력해주세요');
    } else if (user_id.length < 2 || user_id.length > 20) {
      errors.user_id = t('ID는 2~20자로 입력해주세요');
    }
    
    // 비밀번호 검사
    if (!password) {
      errors.password = t('비밀번호를 입력해주세요');
    }
    
    // 핸드폰 번호 검사
    if (!phone) {
      errors.phone = t('핸드폰 번호를 입력해주세요');
    }
    
    // 이름 검사
    if (!name.trim()) {
      errors.name = t('이름을 입력해주세요');
    }
    
    // 이메일 검사 (값이 있을 경우만)
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = t('유효한 이메일 형식이 아닙니다');
    }
    
    // 필수 동의 항목 검사
    Object.entries(varFields).forEach(([fieldKey, fieldConfig]) => {
      if (fieldConfig.show && fieldConfig.type === 'document' && fieldConfig.required && !formData[fieldKey]) {
        errors[fieldKey] = `${fieldConfig.label}을 동의하셔야 합니다.`;
      }
    });
    
    setLocalValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // 폼 제출 핸들러
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 유효성 검사
    if (!validateForm()) {
      return;
    }
    
    // API 전송 데이터 구성
    const apiData = {
      user_id: formData.user_id,
      password: formData.password,
      name: formData.name,
      phone: formData.phone,
      referral_code: formData.referral_code,
      email: formData.email,
      birthday: formData.birthday,
      address: formData.address,
      center_code: formData.center_code,
      var01: formData.var01,
      var02: formData.var02,
      var03: formData.var03
    };
    
    // SPECIFIED 정책일 경우 추가 데이터 포함
    if (isSpecifiedLegPolicy) {
      apiData.upperer_code = formData.upperer_code;
      apiData.left_or_right = formData.left_or_right;
    }
    
    
    try {
      const result = await dispatch(registerUser(apiData)).unwrap();
      // 성공 시 토스트 메시지 표시
      showToast(t("회원가입이 완료되었습니다!"), "success");
    } catch (error) {
      // 에러 메시지 토스트로 표시
      const errorMessage = error.message || t("회원가입에 실패했습니다.");
      showToast(errorMessage, "error");
      
      // 개발 환경에서 디버깅용 콘솔 로그
      console.error(t('[회원가입 에러]'), error);
    }
  };

  // var 필드 렌더링 함수
  const renderVarField = (fieldName, fieldConfig, styleOverride = {}) => {

    if (!fieldConfig || !fieldConfig.show) {
      return null;
    }

    switch (fieldConfig.type) {
      case 'select':
        return (
          <div style={{...formGroupStyle, ...styleOverride}} key={fieldName}>
            <label htmlFor={fieldName} style={labelStyle}>{fieldConfig.label}</label>
            <select
              id={fieldName}
              style={inputStyle}
              value={formData[fieldName]}
              onChange={handleChange}
            >
              <option value="">{t('선택하세요')}</option>
              {fieldConfig.options && fieldConfig.options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        );
      
      case 'radio':
        return (
          <div style={{...formGroupStyle, ...styleOverride}} key={fieldName}>
            <label style={{...labelStyle, marginBottom: '10px'}}>{fieldConfig.label}</label>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '15px'}}>
              {fieldConfig.options && fieldConfig.options.map((option, index) => (
                <label key={index} style={{
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '5px', 
                  cursor: 'pointer',
                  minWidth: '80px',
                  maxWidth: '150px'
                }}>
                  <input
                    type="radio"
                    id={`${fieldName}-${index}`}
                    name={fieldName}
                    value={option.value}
                    checked={formData[fieldName] === option.value}
                    onChange={(e) => {
                      setFormData({...formData, [fieldName]: e.target.value});
                    }}
                    style={{ width: '16px', height: '16px' }}
                  />
                  <span style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '120px'
                  }}>
                    {option.label.length > 10 ? `${option.label.substring(0, 10)}...` : option.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
        );
      
      
      case 'document':
        return (
          <div style={{...formGroupStyle, ...styleOverride}} key={fieldName}>
            <label style={{...labelStyle, marginBottom: '10px'}}>
              {fieldConfig.required ? '* 필수 : ' : ''}{fieldConfig.label} 
            </label>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
              <input 
                type="checkbox" 
                id={fieldName} 
                checked={formData[fieldName] ? true : false} 
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setFormData({
                    ...formData, 
                    [fieldName]: isChecked ? `${fieldConfig.label} 동의함` : ''
                  });
                }}
                style={{ marginRight: '8px', width: '16px', height: '16px' }}
              />
              <label htmlFor={fieldName} style={{cursor: 'pointer', fontSize: '14px'}}>
                동의합니다
              </label>
            </div>
            <div style={{position: 'relative'}}>
              <textarea 
                style={{
                  width: '100%', 
                  height: '80px', 
                  border: '1px solid #ced4da', 
                  borderRadius: '4px', 
                  fontSize: '13px',
                  padding: '8px',
                  resize: 'none',
                  backgroundColor: '#f8f9fa'
                }}
                value={fieldConfig.content || ''}
                readOnly
              />
            </div>
            {validationErrors[fieldName] && (
              <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                {validationErrors[fieldName]}
              </div>
            )}
          </div>
        );
      
      default: // input
        return (
          <div style={{...formGroupStyle, ...styleOverride}} key={fieldName}>
            <label htmlFor={fieldName} style={labelStyle}>{fieldConfig.label}</label>
            <input 
              id={fieldName}
              type="text" 
              placeholder={`${fieldConfig.label} ${t('입력')}`}
              style={inputStyle}
              value={formData[fieldName]}
              onChange={handleChange}
            />
          </div>
        );
    }
  };

  return (
    <div className="signup-form" style={defaultStyle}>
      <h2 style={{ marginTop: 0, marginBottom: '20px', textAlign: 'center' }}>{t('회원가입')}</h2>
      
      {signUpSuccess ? (
        <div style={{ textAlign: 'center', color: 'green', marginBottom: '20px', padding: '15px', backgroundColor: '#f8fff8', borderRadius: '4px' }}>
          <p>{t('회원가입이 완료되었습니다!')}</p>
          <p>{t('잠시 후 홈페이지로 이동합니다.')}</p>
        </div>
      ) : (
        <form style={formStyle} onSubmit={handleSubmit}>
          <div style={sectionTitleStyle}>{t('회원 정보')}</div>
          
          {/* 기본 정보 행 */}
          <div style={formRowStyle}>
            {/* 아이디 입력 필드 */}
            <div style={formGroupStyle}>
              <label htmlFor="user_id" style={labelStyle}>{t('아이디')} *</label>
              <input 
                id="user_id" 
                type="text" 
                placeholder={t('아이디 입력 (2~20자)')} 
                required 
                style={validationErrors.user_id ? errorInputStyle : inputStyle}
                value={formData.user_id}
                onChange={handleChange}
                minLength="2"
                maxLength="20"
              />
              {validationErrors.user_id && (
                <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                  {validationErrors.user_id}
                </div>
              )}
            </div>

            {/* 비밀번호 입력 필드 */}
            <div style={formGroupStyle}>
              <label htmlFor="password" style={labelStyle}>{t('비밀번호')} *</label>
              <input 
                id="password" 
                type="password" 
                placeholder={t('비밀번호 입력')} 
                required 
                style={validationErrors.password ? errorInputStyle : inputStyle}
                value={formData.password}
                onChange={handleChange}
              />
              {validationErrors.password && (
                <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                  {validationErrors.password}
                </div>
              )}
            </div>
          </div>
          
          {/* 개인 정보 행 */}
          <div style={formRowStyle}>
            {/* 이름 입력 필드 */}
            <div style={formGroupStyle}>
              <label htmlFor="name" style={labelStyle}>{t('이름')} *</label>
              <input 
                id="name" 
                type="text" 
                placeholder={t('이름 입력')} 
                required 
                style={validationErrors.name ? errorInputStyle : inputStyle}
                value={formData.name}
                onChange={handleChange}
              />
              {validationErrors.name && (
                <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                  {validationErrors.name}
                </div>
              )}
            </div>
            
            {/* 핸드폰 번호 입력 필드 */}
            <div style={formGroupStyle}>
              <label htmlFor="phone" style={labelStyle}>{t('핸드폰 번호')} *</label>
              <input 
                id="phone" 
                type="tel" 
                placeholder={t('핸드폰 번호 입력')} 
                required 
                style={validationErrors.phone ? errorInputStyle : inputStyle}
                value={formData.phone}
                onChange={handleChange}
              />
              {validationErrors.phone && (
                <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                  {validationErrors.phone}
                </div>
              )}
            </div>
          </div>
          
          {/* 추가 정보 행 */}
          <div style={formRowStyle}>
            {/* 이메일 입력 필드 */}
            {showEmail && (
              <div style={formGroupStyle}>
                <label htmlFor="email" style={labelStyle}>{t('이메일')}</label>
                <input 
                  id="email" 
                  type="email" 
                  placeholder={t('이메일 입력')} 
                  style={validationErrors.email ? errorInputStyle : inputStyle}
                  value={formData.email}
                  onChange={handleChange}
                />
                {validationErrors.email && (
                  <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                    {validationErrors.email}
                  </div>
                )}
              </div>
            )}
            
            {/* 생일 입력 필드 */}
            {showBirthday && (
              <div style={formGroupStyle}>
                <label htmlFor="birthday" style={labelStyle}>{t('생년월일')}</label>
                <input 
                  id="birthday" 
                  type="date" 
                  style={inputStyle}
                  value={formData.birthday}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>
          
          {/* 주소 입력 필드 */}
          {showAddress && (
            <div style={formRowStyle}>
              <div style={{...formGroupStyle, flex: '1 1 100%'}}>
                <label htmlFor="address" style={labelStyle}>{t('주소')}</label>
                <input 
                  id="address" 
                  type="text" 
                  placeholder={t('주소 입력')} 
                  style={inputStyle}
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
          
          {/* 추천인 코드 필드 */}
          <div style={formRowStyle}>
            {/* API에서 가져온 referralCode가 있을 때 숨김 처리 */}
            <div style={{
              ...formGroupStyle, 
              display: directReferralCode && formData.referral_code_from_url ? 'none' : 'block'
            }}>
              <label htmlFor="referral_code" style={labelStyle}>{t('추천인 코드')}</label>
              <input 
                id="referral_code" 
                type="text" 
                placeholder={t('추천인 코드 입력')} 
                style={validationErrors.referral_code ? errorInputStyle : inputStyle}
                value={formData.referral_code}
                onChange={handleChange}
                readOnly={!!formData.referral_code_from_url}
              />
              {formData.referral_code_from_url && formData.referral_code && (
                <div style={{ color: '#28a745', fontSize: '12px', marginTop: '4px' }}>
                  {t('추천인 코드가 자동으로 입력되었습니다.')}
                </div>
              )}
            </div>
            
            {/* var01 필드를 더 넓게 설정 (추천인 코드가 숨겨졌을 때) */}
            {directReferralCode && formData.referral_code_from_url ? 
              renderVarField('var01', varFields.var01, {flex: '1 1 100%'}) : 
              renderVarField('var01', varFields.var01)
            }
          </div>
          
          {/* var02, var03 커스텀 필드 (보여줄 필드가 있는 경우만 행 렌더링) */}
          {varFields && (varFields.var02?.show || varFields.var03?.show) && (
            <div style={formRowStyle}>
              {renderVarField('var02', varFields.var02)}
              {renderVarField('var03', varFields.var03)}
            </div>
          )}
          
          {/* SPECIFIED 정책일 경우만 표시되는 필드들 */}
          {isSpecifiedLegPolicy && (
            <div style={formRowStyle}>
              {/* 후원인 코드 필드 */}
              <div style={formGroupStyle}>
                <label htmlFor="upperer_code" style={labelStyle}>{t('후원인 코드')}</label>
                <input 
                  id="upperer_code" 
                  type="text" 
                  placeholder={t('후원인 코드 입력')} 
                  style={inputStyle}
                  value={formData.upperer_code}
                  onChange={handleChange}
                />
              </div>
              
              {/* 좌/우 선택 필드 */}
              <div style={formGroupStyle}>
                <label htmlFor="left_or_right" style={labelStyle}>{t('좌/우 선택')}</label>
                <select
                  id="left_or_right"
                  style={inputStyle}
                  value={formData.left_or_right}
                  onChange={handleChange}
                >
                  <option value="0">{t('좌')}</option>
                  <option value="1">{t('우')}</option>
                </select>
              </div>
            </div>
          )}

          {/* 센터 코드 필드 (showCenterCode가 true일 때만 표시) */}
          {showCenterCode && (
            <div style={formRowStyle}>
              <div style={formGroupStyle}>
                <label htmlFor="center_code" style={labelStyle}>{t(centerCodeLabel)}</label>
                <input 
                  id="center_code" 
                  type="text" 
                  placeholder={t(`${centerCodeLabel} 입력`)} 
                  style={inputStyle}
                  value={formData.center_code}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          )}


          {/* 오류 메시지 표시 */}
          {signUpError && (
            <div style={{ display: 'none' }}> {/* 기존 에러 메시지 숨김 처리 */}
              {signUpError}
            </div>
          )}

          {/* 회원가입 버튼 */}
          <button 
            type="submit" 
            style={{
              ...buttonStyle,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer',
              backgroundColor: loading ? secondaryColor : primaryColor,
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
            disabled={loading}
          >
            {loading ? t('처리 중...') : t('회원가입')}
          </button>
        </form>
      )}
    </div>
  );
};

export default SignUpComponent; 